// global vars
var globalLang,
    path = $('body').attr('data-path');

// Load CSS by JS to avoid Cloudflare inlinify https://github.com/cloudflare/collapsify
$.get(path+'css/error.pages.css', function(result){
    $("<style rel='stylesheet' type='text/css'></style>").appendTo("head").html(result);
    $('body').fadeIn('fast');
});

// Lang switch
$('.js-lang-switch').click(function(event){
    var lang = $(this).attr('data-target-lang');
    $('body')
        .removeClass('is-de is-en')
        .addClass('is-'+lang);
    $('html').attr('lang',lang);
    localStorage.setItem('errorpage-lang',lang);
    globalLang = lang;
});
if (window.navigator.language.indexOf('de-') !== 0 || localStorage.getItem('errorpage-lang') == 'en') {
    $('body')
        .removeClass('is-de')
        .addClass('is-en');
    globalLang = 'en';
}else{
    globalLang = 'de';
}

// Add projects slider
$('.js-show-projects').click(function(event){
    $('.js-errorpage').fadeOut('fast');
    $.get(path+'uftw-'+globalLang+'.html',function(result){
        $('.js-projects').show().html(result);
        initProjects();
    });
});

// Back from slider
$(document.body).on('click','.js-back',function(event){
    event.preventDefault();
    $('.js-projects').fadeOut('fast', function(){
        $('.js-errorpage').fadeIn('fast');
    });
});